import React from "react";
import { Route, Routes } from "react-router";
import Address from "./Address";
import Cart from "./Cart";
import Checkout from "./Checkout";
import Homepage from "./Homepage";
import Login from "./Login";
import Otp from "./Otp";
import ProductPage from "./ProductPage";
import SignUp from "./SignUp";

function AllRoutes() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Homepage />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/signup" element={<SignUp />}></Route>
        <Route path="/products" element={<ProductPage />}></Route>
        <Route path="/cart" element={<Cart />}></Route>
        <Route path="/address" element={<Address />}></Route>
        <Route path="/checkout" element={<Checkout />}></Route>
        <Route path="/otp" element={<Otp />}></Route>
      </Routes>
    </div>
  );
}

export default AllRoutes;
